export const convertToAMPM = (time) => {
  const hours = time.$H;
  const minutes = time.$m;
  const timeObj = new Date();
  timeObj.setHours(hours);
  timeObj.setMinutes(minutes);
  const formattedTime = timeObj.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  return formattedTime;
};
